import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { FormDocBuilder } from 'src/app/core/models/physician/form-doc-builder';
import { SupportRequestAttachmentRes } from 'src/app/core/models/searchSupportRequestList';
import { FormService, FormServiceResolver } from 'src/app/core/services/v2/form.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { FormPreviewComponent } from './form-preview.component';

@Component({
  selector: 'app-form-preview-fromBuilder',
  templateUrl: './form-preview.component2.html',
  styleUrls: ['./form-preview.component.scss']
})
export class FormPreviewFromBuilderDtoComponent extends FormPreviewComponent  implements OnInit {

  formbuilderDto : FormDocBuilder;

  constructor( private _sanitizer: DomSanitizer, private _formService: FormService, private _formServiceResolver: FormServiceResolver, private loader : WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super( _sanitizer, _formServiceResolver, data);
      this.formbuilderDto = data.formDocBuilder;
    };
    


  GetFormHtmlBlob() : Observable<Blob>
  {
    return this.loader.blockWithLoader(this._formService.generateFormPeviewHtml(this.formbuilderDto));
  }
  
}
